export { default } from './ClaimDiscussion';
export * from './ClaimDiscussion';
